import { prop } from '.';
import { resolveBaseUrlByLang } from '../utilities/index';

export function getImagePath(
  filename,
  { width, height } = { width: 64, height: 80 },
  noSize = false,
  webp = false,
  typeCover = false,
) {
  if (height === 0) {
    return `${process.env.REACT_APP_API_IMAGE_URL ||
      process.env
        .REACT_APP_API_BASE_URL}/image?query=${filename}&width=${width}&webp=${
      webp ? 1 : 0
    }${typeCover ? '&type=cover' : ''}`;
  }

  return noSize
    ? `${process.env.REACT_APP_API_IMAGE_URL ||
        process.env.REACT_APP_API_BASE_URL}/image?query=${filename}&webp=${
        webp ? 1 : 0
      }${typeCover ? '&type=cover' : ''}`
    : `${process.env.REACT_APP_API_IMAGE_URL ||
        process.env
          .REACT_APP_API_BASE_URL}/image?query=${filename}&width=${width}&height=${height}&webp=${
        webp ? 1 : 0
      }${typeCover ? '&type=cover' : ''}`;
}

export function getFilePath(filename) {
  return `${process.env.REACT_APP_API_IMAGE_URL ||
    process.env.REACT_APP_API_BASE_URL}/file?query=${filename}`;
}

export function resolveProductName(data: any) {
  return (
    prop(data, 'publish.0.product_name') ||
    prop(data, 'name', '') ||
    prop(data, 'product_name', '')
  );
}
